import { Avatar } from '@material-ui/core';
import React, { useEffect, useState, useRef } from 'react';
import { useVideo } from '../../api/VideoProvider';
import { pRecordTime, pStatus } from '../../utils/parameters';
import { useTranslation } from "react-i18next";


export function CountdownTimer(props) {
    const { offset, startRecording, settings } = props;
    const { t } = useTranslation("global")

    const { faceStatus, setFaceStatus } = useVideo();
    const [counter, setCounter] = useState(pRecordTime.countdown);
    const [ speedTimer, setSpeedTimer ] = useState(1);
    // const [ timer, setTimer ] = useState(1000);
    const timer = useRef(1000);


    useEffect(() => {
        if (settings !== undefined){
            timer.current = Math.floor(1000 / settings.speedCountDownTimer);
        }
    }, [settings]);

    /* Start timer if the init signal is set to true */
    useEffect(() => {
        if (faceStatus === pStatus.countdown) {
            if (counter > 0) {
                setTimeout(() => setCounter(counter - 1), timer.current);
                // if (offset && counter===1){
                //     // console.log('START ANTES!!!!!!!!!!!!!')
                //     startRecording()
                // }
            }
            else if (counter === 0) {
                setFaceStatus(pStatus.record);
                setCounter(pRecordTime.countdown);
            }
        }
    }, [counter]);

    /* MOB - I separated the useEffect in two parts to allow the counter to reach "0" and keep showing 
    "0" during the small transition applied to the new "Countdown PopUp". Other than that, everything should
    work the same way.*/
    useEffect(() => {
        if (faceStatus === pStatus.countdown) {
            setCounter(pRecordTime.countdown);
        } else {
            setCounter(0);
        }
    }, [faceStatus, setFaceStatus]);

    return (
        <>
            <div className={`sig_Home_CountdownContainer ${faceStatus === 3 ? '' : 'sig_Home_CountdownContainerHidden'}`}>
                <p className='sig_Home_CountdownTitle'> {t("sRecordComponent.recording_in")} </p>
                <Avatar className='sig_Home_Countdown'>{counter}</Avatar>
            </div>
        </>
    );
}